"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewActions = void 0;
const react_1 = require("react");
const ViewActionsContext_1 = __importDefault(require("./ViewActionsContext"));
function useViewActions(viewId) {
    const actionsCtx = (0, react_1.useContext)(ViewActionsContext_1.default);
    const addFilter = (0, react_1.useCallback)((filter) => actionsCtx.addFilter(viewId)(filter), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const removeFilter = (0, react_1.useCallback)((filter) => actionsCtx.removeFilter(viewId)(filter), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleFilter = (0, react_1.useCallback)((filter) => actionsCtx.toggleFilter(viewId)(filter), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setFilters = (0, react_1.useCallback)((filters) => actionsCtx.setFilters(viewId)(filters), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const addGroupBy = (0, react_1.useCallback)((groupBy) => actionsCtx.addGroupBy(viewId)(groupBy), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const removeGroupBy = (0, react_1.useCallback)((groupBy) => actionsCtx.removeGroupBy(viewId)(groupBy), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleGroupBy = (0, react_1.useCallback)((groupBy) => actionsCtx.toggleGroupBy(viewId)(groupBy), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setGroupBys = (0, react_1.useCallback)((groupBys) => actionsCtx.setGroupBys(viewId)(groupBys), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const addField = (0, react_1.useCallback)((field) => actionsCtx.addField(viewId)(field), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const removeField = (0, react_1.useCallback)((field) => actionsCtx.removeField(viewId)(field), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const toggleField = (0, react_1.useCallback)((field) => actionsCtx.toggleField(viewId)(field), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const setFields = (0, react_1.useCallback)((fields) => actionsCtx.setFields(viewId)(fields), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const moveField = (0, react_1.useCallback)((oldIndex, newIndex) => actionsCtx.moveField(viewId)(oldIndex, newIndex), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setReportPage = (0, react_1.useCallback)((page) => actionsCtx.setReportPage(viewId)(page), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setSortBy = (0, react_1.useCallback)((field, desc) => actionsCtx.setSortBy(viewId)(field, desc), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setPinField = (0, react_1.useCallback)((field) => actionsCtx.setPinField(viewId)(field), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleHighlightedGroup = (0, react_1.useCallback)((group, force) => actionsCtx.toggleHighlightedGroup(viewId)(group, force), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleHighlightedDateRange = (0, react_1.useCallback)((range, force) => actionsCtx.toggleHighlightedDateRange(viewId)(range, force), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleHighlightedField = (0, react_1.useCallback)((field, force) => actionsCtx.toggleHighlightedField(viewId)(field, force), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleHighlightedItem = (0, react_1.useCallback)((item, force) => actionsCtx.toggleHighlightedItem(viewId)(item, force), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const shiftDateFilter = (0, react_1.useCallback)((key, amount) => actionsCtx.shiftDateFilter(viewId)(key, amount), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const toggleChartBox = (0, react_1.useCallback)((visible) => actionsCtx.toggleChartBox(viewId)(visible), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setChartBox = (0, react_1.useCallback)((chartBox) => actionsCtx.setChartBox(viewId)(chartBox), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const updateChart = (0, react_1.useCallback)((chart) => actionsCtx.updateChart(viewId)(chart), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const refresh = (0, react_1.useCallback)(() => actionsCtx.refresh(viewId)(), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setHideEmptyGroups = (0, react_1.useCallback)((v) => actionsCtx.setHideEmptyGroups(viewId)(v), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    const setBooleanFilter = (0, react_1.useCallback)((qfk, v) => actionsCtx.setBooleanFilter(viewId)(qfk, v), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewId]);
    return {
        addFilter,
        removeFilter,
        toggleFilter,
        setFilters,
        addGroupBy,
        removeGroupBy,
        toggleGroupBy,
        setGroupBys,
        addField,
        removeField,
        toggleField,
        setFields,
        moveField,
        setReportPage,
        setSortBy,
        setPinField,
        setHideEmptyGroups,
        toggleHighlightedGroup,
        toggleHighlightedDateRange,
        toggleHighlightedField,
        toggleHighlightedItem,
        shiftDateFilter,
        toggleChartBox,
        setChartBox,
        updateChart,
        refresh,
        setBooleanFilter,
    };
}
exports.useViewActions = useViewActions;
exports.default = useViewActions;
